import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.PayeeType.Delete.IRequest;
type Response = Api.Core.PayeeType.Delete.IResponse;
type Headers = Api.Core.PayeeType.Delete.IHeaders;
const url = '/api/Management/PayeeType/:id';
export default async function payeeTypeDeleteApi(id: number): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
